import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
  .set('GetIndicators', new Immutable.Map({}))
  .set('UpdateIndicators', new Immutable.Map({}))
  .set('GetLessons', new Immutable.Map({}))
  .set('UpdateLessons', new Immutable.Map({}))
  .set('GetPromotion', new Immutable.Map({}))
  .set('UpdatePromotion', new Immutable.Map({}))
  .set('GetImprovement', new Immutable.Map({}))
  .set('UpdateImprovement', new Immutable.Map({}))
  .set('GetResponsible', new Immutable.Map({}))
  .set('UpdateResponsible', new Immutable.Map({}))
  .set('GetBreakdownIndicator', new Immutable.Map({}))
  .set('AddBreakdownIndicator', new Immutable.Map({}))
  .set('UpdateIndicatorsResults', new Immutable.Map({}))
  .set('GetExpenditure', new Immutable.Map({}))
  .set('UpdateExpenditure', new Immutable.Map({}))
  .set('AddReport', new Immutable.Map({}))

/*Types*/
export const ACTION_GET_INDICATORS_RESULTS = 'ACTION_GET_INDICATORS_RESULTS'
export const ACTION_UPDATE_INDICATORS_RESULTS = 'ACTION_UPDATE_INDICATORS_RESULTS'
export const ACTION_GET_LESSONS = 'ACTION_GET_LESSONS'
export const ACTION_UPDATE_LESSONS = 'ACTION_UPDATE_LESSONS'
export const ACTION_GET_PROMOTION = 'ACTION_GET_PROMOTION'
export const ACTION_UPDATE_PROMOTION = 'ACTION_UPDATE_PROMOTION'
export const ACTION_GET_IMPROVEMENT = 'ACTION_GET_IMPROVEMENT'
export const ACTION_UPDATE_IMPROVEMENT = 'ACTION_UPDATE_IMPROVEMENT'
export const ACTION_GET_RESPONSIBLE = 'ACTION_GET_RESPONSIBLE'
export const ACTION_UPDATE_RESPONSIBLE = 'ACTION_UPDATE_RESPONSIBLE'
export const ACTION_GET_BREAKDOWN_INDICATOR = 'ACTION_GET_BREAKDOWN_INDICATOR'
export const ACTION_ADD_BREAKDOWN_INDICATOR = 'ACTION_ADD_BREAKDOWN_INDICATOR'
export const ACTION_UPDATE_INDICATORS_RESULTS_PROGRAM = 'ACTION_UPDATE_INDICATORS_RESULTS_PROGRAM'
export const ACTION_GET_EXPENDITURE = 'ACTION_GET_EXPENDITURE'
export const ACTION_UPDATE_EXPENDITURE = 'ACTION_UPDATE_EXPENDITURE'
export const ACTION_GET_REPORT = 'ACTION_GET_REPORT'

/*Reducer*/
export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_GET_INDICATORS_RESULTS:
      return state.set('GetIndicators', new Immutable.Map(action.Obj))
    case ACTION_UPDATE_INDICATORS_RESULTS:
      return state.set('UpdateIndicators', new Immutable.Map(action.Obj))
    case ACTION_GET_LESSONS:
      return state.set('GetLessons', new Immutable.Map(action.Obj))
    case ACTION_UPDATE_LESSONS:
      return state.set('UpdateLessons', new Immutable.Map(action.Obj))
    case ACTION_GET_PROMOTION:
      return state.set('GetPromotion', new Immutable.Map(action.Obj))
    case ACTION_UPDATE_PROMOTION:
      return state.set('UpdatePromotion', new Immutable.Map(action.Obj))
    case ACTION_GET_IMPROVEMENT:
      return state.set('GetImprovement', new Immutable.Map(action.Obj))
    case ACTION_UPDATE_IMPROVEMENT:
      return state.set('UpdateImprovement', new Immutable.Map(action.Obj))
    case ACTION_GET_RESPONSIBLE:
      return state.set('GetResponsible', new Immutable.Map(action.Obj))
    case ACTION_UPDATE_RESPONSIBLE:
      return state.set('UpdateResponsible', new Immutable.Map(action.Obj))
    case ACTION_GET_BREAKDOWN_INDICATOR:
      return state.set('GetBreakdownIndicator', new Immutable.Map(action.Obj))
    case ACTION_ADD_BREAKDOWN_INDICATOR:
      return state.set('AddBreakdownIndicator', new Immutable.Map(action.Obj))
    case ACTION_UPDATE_INDICATORS_RESULTS_PROGRAM:
      return state.set('UpdateIndicatorsResults', new Immutable.Map(action.Obj))
    case ACTION_GET_EXPENDITURE:
      return state.set('GetExpenditure', new Immutable.Map(action.Obj))
    case ACTION_UPDATE_EXPENDITURE:
      return state.set('UpdateExpenditure', new Immutable.Map(action.Obj))
    default:
      return state
  }
}

/*Action Creators*/

export const getIndicatorsResults = form => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getIndicatorsResults',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_INDICATORS_RESULTS, Obj: response.data })
        return response
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const updateIndicatorsResults = form => {
  let temp = {
    idInformeResultado: form.idInformeResultado,
    idDonataria: form.idDonataria,
    idCorrida: form.idCorrida,
    preguntas: [
      {
        idPregunta: form.preguntas.programResultsData[0].idPregunta,
        respuesta: form.questionResult2 || ''
      },
      {
        idPregunta: form.preguntas.programResultsData[1].idPregunta,
        respuesta: form.questionResult3 || ''
      },
      {
        idPregunta: form.preguntas.programResultsData[2].idPregunta,
        respuesta: form.questionResult4 || ''
      },
      {
        idPregunta: form.preguntas.programResultsData[3].idPregunta,
        respuesta: form.questionResult5 || ''
      },
      {
        idPregunta: form.preguntas.programResultsData[4].idPregunta,
        respuesta: form.questionResult6 || ''
      },
      {
        idPregunta: form.preguntas.programResultsData[5].idPregunta,
        respuesta: form.questionResult7 || ''
      },
      {
        idPregunta: form.preguntas.programResultsData[6].idPregunta,
        respuesta: form.questionResult8 || ''
      }
    ],
    evidenciasIndicadores: Utils.unionArray(
      Utils.getListPropsOmit(form.programResultsDocs, ['documento', 'nombre', 'id']),
      form.programResultsDocsRemove
    )
  }

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/updateIndicatorsResults',
      method: 'POST',
      data: { ...temp },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_UPDATE_INDICATORS_RESULTS, Obj: response.data })
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const getLessonsDecisions = form => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getLessonsDecisions',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_LESSONS, Obj: response.data })
        return response
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const updateLessonsDecisions = form => {
  let temp = {
    idInformeResultado: form.idInformeResultado,
    idDonataria: form.idDonataria,
    idCorrida: form.idCorrida,
    preguntas: [
      {
        idPregunta: form.preguntas.lessonsData[0].idPregunta,
        respuesta: form.questionLesson21 || ''
      },
      {
        idPregunta: form.preguntas.lessonsData[1].idPregunta,
        respuesta: form.questionLesson22 || ''
      }
    ],
    otrosActores: null
  }
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/updateLessonsDecisions',
      method: 'POST',
      data: { ...temp },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_UPDATE_LESSONS, Obj: response.data })
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const getPromotionHumanRights = form => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getPromotionHumanRights',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_PROMOTION, Obj: response.data })
        return response
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const updatePromotionHumanRights = form => {
  let otrosActores = Utils.unionArray(
    Utils.getListPropsOmit(form.promotionData, ['id', 'tmp', 'consecutivo']),
    Utils.getListPropsOmit(form.promotionDataRemove, ['id', 'tmp', 'consecutivo'])
  )
  let temp = {
    idInformeResultado: form.idInformeResultado,
    idDonataria: form.idDonataria,
    idCorrida: form.idCorrida,
    preguntas: [
      {
        idPregunta: form.preguntas.promotionData[0].idPregunta,
        respuesta: form.questionPromotion31 || ''
      },
      {
        idPregunta: form.preguntas.promotionData[1].idPregunta,
        respuesta: form.questionPromotion32 || ''
      },
      {
        idPregunta: form.preguntas.promotionData[2].idPregunta,
        respuesta: form.questionPromotion33 || ''
      }
    ],
    otrosActores
  }

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/updatePromotionHumanRights',
      method: 'POST',
      data: { ...temp },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_UPDATE_PROMOTION, Obj: response.data })
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const getImprovementActions = form => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getImprovementActions',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_IMPROVEMENT, Obj: response.data })
        return response
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const updateImprovementActions = form => {
  let temp = {
    idInformeResultado: form.idInformeResultado,
    idDonataria: form.idDonataria,
    idCorrida: form.idCorrida,
    preguntas: [
      {
        idPregunta: form.preguntas.improvementData[0].idPregunta,
        respuesta: form.questionImprovement51 || ''
      },
      {
        idPregunta: form.preguntas.improvementData[1].idPregunta,
        respuesta: form.questionImprovement52 || ''
      }
    ],
    otrosActores: null
  }

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/updateImprovementActions',
      method: 'POST',
      data: { ...temp },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_UPDATE_IMPROVEMENT, Obj: response.data })
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const getResponsibleProgram = form => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getResponsibleProgram',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_RESPONSIBLE, Obj: response.data })
        return response
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const updateResponsibleProgram = form => {
  let date = null

  if (form.sendDate) {
    let str = form.sendDate.substr(0, 10).split('-')
    date = `${str[2]}-${str[1]}-${str[0]}`
  }

  let temp = {
    idInformeResultado: form.idInformeResultado,
    idDonataria: form.idDonataria,
    idCorrida: form.idCorrida,
    responsablePrograma: form.responsablePrograma,
    fecha: date,
    estado: null
  }

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/updateResponsibleProgram',
      method: 'POST',
      data: { ...temp },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_UPDATE_RESPONSIBLE, Obj: response.data })
        return response
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const breakdownIndicator = form => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/breakdownIndicator',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_BREAKDOWN_INDICATOR, Obj: response.data })
        return response
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const addBreakdownIndicator = form => {
  let respuestasNuevas = Utils.getListPropsOmit(form.respuestasNuevas, ['tmp'])

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/addBreakdownIndicator',
      method: 'POST',
      data: { respuestasNuevas },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_ADD_BREAKDOWN_INDICATOR, Obj: response.data })
        return response
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const updateIndicatorsResultsProgram = form => {
  let temp = {
    idResultadoProgramaIndicador: form.idResultadoProgramaIndicador,
    metaAlcanzada: form.goalAchieved
  }

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/updateIndicatorsResultsProgram',
      method: 'POST',
      data: { ...temp },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_UPDATE_INDICATORS_RESULTS_PROGRAM, Obj: response.data })
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const getExpenditure = form => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getExpenditure',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_EXPENDITURE, Obj: response.data })
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const updateExpenditure = form => {
  let temp = {
    idDonataria: form.idDonataria,
    idInforme: form.idInformeResultado,
    idCorrida: form.idCorrida,
    comprobanteGasto: form.distributionDataRubros,
    preguntas: [
      {
        idPregunta: form.preguntas.distributionDataRubros[0].idPregunta,
        respuesta: form.questionDistribution
      },
      {
        idPregunta: form.preguntas.distributionDataRubros[1].idPregunta,
        respuesta: form.questionDistribution43
      }
    ]
  }

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/updateExpenditure',
      method: 'POST',
      data: { ...temp },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_UPDATE_EXPENDITURE, Obj: response.data })
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const updateExpenditureItem = form => {
  const { idDonataria, idCorrida, idInformeResultado } = form
  let { rubroEdited } = form
  delete rubroEdited.conceptoTabla
  delete rubroEdited.conceptoEditadoTabla

  let temp = {
    idDonataria: idDonataria,
    idInforme: idInformeResultado,
    idCorrida: idCorrida,
    comprobanteGasto: [rubroEdited]
  }

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/updateExpenditure',
      method: 'POST',
      data: { ...temp },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const deleteDocumentItem = id => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/deleteDocumentItem',
      method: 'POST',
      data: { id },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const addReport = form => {
  let params = {
    idIndicador: form.idIndicador,
    idMeta: form.idMeta,
    idObjetivo: form.idObjetivo,
    id_informe_resultado: form.idInformeResultado
  }

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/addReport',
      method: 'POST',
      data: { ...params },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid }),
      responseType: 'arraybuffer'
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))

        const blob = new Blob([response.data], { type: 'application/pdf' })
        const fileName = `desglose-indicadores-resultados-${Utils.getToday()}.pdf`
        const objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')

        a.href = objectUrl
        a.download = fileName
        document.body.appendChild(a)
        a.click()

        document.body.removeChild(a)
        URL.revokeObjectURL(objectUrl)
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const generateReport = idReporte => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/generateReport',
      method: 'POST',
      data: { idReporte },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid }),
      responseType: 'arraybuffer'
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))

        const blob = new Blob([response.data], { type: 'application/pdf' })
        const fileName = `informe-resultados-reporte-${Utils.getToday()}.pdf`
        const objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')

        a.href = objectUrl
        a.download = fileName
        document.body.appendChild(a)
        a.click()

        document.body.removeChild(a)
        URL.revokeObjectURL(objectUrl)
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const clearResultsReport = () => {
  return dispatch => {
    dispatch({ type: ACTION_GET_INDICATORS_RESULTS, Obj: {} })
    dispatch({ type: ACTION_UPDATE_INDICATORS_RESULTS, Obj: {} })
    dispatch({ type: ACTION_GET_LESSONS, Obj: {} })
    dispatch({ type: ACTION_UPDATE_LESSONS, Obj: {} })
    dispatch({ type: ACTION_GET_PROMOTION, Obj: {} })
    dispatch({ type: ACTION_UPDATE_PROMOTION, Obj: {} })
    dispatch({ type: ACTION_GET_IMPROVEMENT, Obj: {} })
    dispatch({ type: ACTION_UPDATE_IMPROVEMENT, Obj: {} })
    dispatch({ type: ACTION_GET_RESPONSIBLE, Obj: {} })
    dispatch({ type: ACTION_UPDATE_RESPONSIBLE, Obj: {} })
    dispatch({ type: ACTION_GET_BREAKDOWN_INDICATOR, Obj: {} })
    dispatch({ type: ACTION_ADD_BREAKDOWN_INDICATOR, Obj: {} })
    dispatch({ type: ACTION_UPDATE_INDICATORS_RESULTS_PROGRAM, Obj: {} })
    dispatch({ type: ACTION_GET_EXPENDITURE, Obj: {} })
    dispatch({ type: ACTION_UPDATE_EXPENDITURE, Obj: {} })
  }
}



// WEBPACK FOOTER //
// ./src/modules/ResultsReport/ResultsReport.js